import React from 'react';
import { Field } from 'formik';
import clsx from 'clsx';

const TextInput = ({ disabled, className, inputClassName, ...props }) => {
  const node = React.useRef();

  React.useEffect(() => {
    if (props.type !== 'number') return;

    const handleWheel = e => {
      e.preventDefault();
      e.stopPropagation();
      node.current?.blur();
    };

    const element = node.current;
    if (element) {
      element.addEventListener('wheel', handleWheel, { passive: false });

      return () => {
        element.removeEventListener('wheel', handleWheel);
      };
    }
  }, [props.type]);

  return (
    <Field
      {...props}
      type={props.type || 'text'}
      innerRef={node}
      as="input"
      className={clsx(
        'appearance-none block w-full py-1.5 px-2 text-gray-800 rounded border-none shadow-input focus:shadow-input-focus',
        { 'opacity-50': disabled },
        className,
        inputClassName,
      )}
      disabled={disabled}
    />
  );
};

export default TextInput;
